import { connect } from "react-redux"

import {
    keyIssueAddPlaceholderImages,
    keyIssueUpdatePlaceholderAttribution,
    keyIssueRemovePlaceholder
} from "../../../../actions/key-issue-actions"

import PlaceholderImageEditWidget from "../../../common/PlaceholderImageEditWidget"

const mapStateToProps = (_, props) => props

const mapDispatchToProps = dispatch => ({
    onAddPlaceholders: files => dispatch(keyIssueAddPlaceholderImages(files)),
    onUpdatePlaceholder: placeholder =>
        dispatch(keyIssueUpdatePlaceholderAttribution(placeholder)),
    onRemovePlaceholder: placeholderId =>
        dispatch(keyIssueRemovePlaceholder(placeholderId))
})

export default connect(mapStateToProps, mapDispatchToProps)(
    PlaceholderImageEditWidget
)
